"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var GroupHeading = /** @class */ (function (_super) {
            __extends(GroupHeading, _super);
            function GroupHeading() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.Shortcuts = $dyn.extendPrototype($dyn.ui.Control.prototype.Shortcuts, {
                    CollapseHeading: {
                        Description: $dyn.label("Group_Collapse"),
                        Handler: function (event) {
                            if (_this.props.Expanded) {
                                _this.onClick && _this.onClick(event);
                            }
                        },
                        Keys: { keyCode: $dyn.ui.KeyCodes.leftArrow },
                        ShowToUser: function () {
                            return _this.props.Expanded;
                        },
                    },
                    ExpandHeading: {
                        Description: $dyn.label("Group_Expand"),
                        Handler: function (event) {
                            if (!_this.props.Expanded) {
                                _this.onClick && _this.onClick(event);
                            }
                        },
                        Keys: { keyCode: $dyn.ui.KeyCodes.rightArrow },
                        ShowToUser: function () {
                            return !_this.props.Expanded;
                        },
                    },
                    ToggleHeading: {
                        Description: function () {
                            var description = "";
                            if (_this.props.Expanded) {
                                description = $dyn.label("Group_Collapse");
                            }
                            else {
                                description = $dyn.label("Group_Expand");
                            }
                            return description;
                        },
                        Handler: function (event) {
                            _this.onClick && _this.onClick(event);
                        },
                        Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                    },
                });
                _this.keyHandler = function (event) {
                    $dyn.util.handleShortcuts(_this, event.nativeEvent);
                };
                return _this;
            }
            GroupHeading.prototype.onmouseenter = function (event) {
                $dyn.superTooltip.tryOpenSuperTooltip(event.target);
            };
            return GroupHeading;
        }(React.PureComponent));
        DynReact.GroupHeading = GroupHeading;
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=GroupHeading.js.map
